import Layout from 'antd/lib/layout';
import Typography from 'antd/lib/typography';
import React from 'react';
import { SidebarWrapper } from 'src/components/sidebar-filters/SidebarWrapper';
import { SidebarFiltersGroupCollapse } from 'src/components/sidebar-filters/SidebarFiltersGroupCollapse';
import { CUSTOMER_UTILITY_BILL_SIDEBAR } from './consts';
import { IBillSidebarFilters } from './billSidebarFilters';
import { CustomerUtilityBillSidebarTabs } from './CustomerUtilityBillSidebarTabs';

interface Props {
    collapsed: boolean;
    onCollapseChange: (v: boolean) => void;
    filters: IBillSidebarFilters;
    onChange: (f: IBillSidebarFilters) => void;
    onClearFilters: () => void;
    totalRecords: number;
    utilityOptions: { value: string; label: string }[];
}

export const CustomerUtilityBillSidebar: React.FC<Props> = ({
    collapsed,
    onCollapseChange,
    filters,
    onChange,
    onClearFilters,
    totalRecords,
    utilityOptions,
}) => {
    return (
        <SidebarWrapper
            collapsed={collapsed}
            onCollapseChange={onCollapseChange}
            collapsedWidth={CUSTOMER_UTILITY_BILL_SIDEBAR.collapsedWidth}
            expandedWidth={CUSTOMER_UTILITY_BILL_SIDEBAR.expandedWidth}
        >
            <Layout.Content style={{ padding: 0, margin: 0, height: '100%' }}>
                {!collapsed && (
                    <div style={{ padding: '14px 12px 8px' }}>
                        <Typography.Text>Total Records: {totalRecords}</Typography.Text>
                    </div>
                )}

                <SidebarFiltersGroupCollapse collapsed={collapsed} setCollapsed={onCollapseChange} selectedItemsCount={0} />

                {!collapsed && (
                    <CustomerUtilityBillSidebarTabs
                        filters={filters}
                        onChange={onChange}
                        onClearFilters={onClearFilters}
                        utilityOptions={utilityOptions}
                    />
                )}
            </Layout.Content>
        </SidebarWrapper>
    );
};
